"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSubscriptionCapability = void 0;
/**
 * Actions a user can take on their subscription
 */
var UserSubscriptionCapability;
(function (UserSubscriptionCapability) {
    UserSubscriptionCapability["USER_SUBSCRIPTION_MANAGE_WEB"] = "user_subscription:manage_web";
    UserSubscriptionCapability["USER_SUBSCRIPTION_MANAGE_TSC_WEB"] = "user_subscription:manage_tsc_web";
    UserSubscriptionCapability["USER_SUBSCRIPTION_MANAGE_MOBILE"] = "user_subscription:manage_mobile";
    UserSubscriptionCapability["USER_SUBSCRIPTION_MANAGE_TSC_MOBILE"] = "user_subscription:manage_tsc_mobile";
    UserSubscriptionCapability["USER_SUBSCRIPTION_CANCEL"] = "user_subscription:cancel";
    UserSubscriptionCapability["USER_SUBSCRIPTION_RESUBSCRIBE"] = "user_subscription:resubscribe";
    UserSubscriptionCapability["USER_SUBSCRIPTION_CHANGE_PAYMENT_METHOD"] = "user_subscription:change_payment_method";
})(UserSubscriptionCapability || (exports.UserSubscriptionCapability = UserSubscriptionCapability = {}));
